export default __webpack_public_path__ + "static/media/fireFN36.a06ee79e.svg";